import React, { Component } from 'react';
import { Container, Row, Col, Button, Form, Spinner, Modal, Alert } from 'react-bootstrap';
import { EditorState, convertToRaw, convertFromRaw} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { Link } from 'react-router-dom';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { showArticleCreatedNotification, showArticleDeletedNotification} from '../../redux/modules/notifications'
import { connect } from 'react-redux';
import './styles/styles.scss';
import './styles/react-draft-wysiwyg.css';

const getHtml = editorState => draftToHtml(convertToRaw(editorState.getCurrentContent()));

const select = state => {
  return {
    token: state.auth.token
  };
};

function mapDispatchToProps(dispatch) {
  return {
    showArticleCreatedNotification: () => dispatch(showArticleCreatedNotification()),
    showArticleDeletedNotification: () => dispatch(showArticleDeletedNotification())
  };
}

class ConnectedBlogArticleComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      show: false,
      showPreview: false,
      showDeleteModal: false,
      deleting: false,
      isLoading: true,
      articleNotFound: false,
      title: '',
      abstract: '',
      editorState: EditorState.createEmpty()
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleClosePreview = this.handleClosePreview.bind(this);
    this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this);
    this.handleShowPreview = this.handleShowPreview.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.handleDeleteArticle = this.handleDeleteArticle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onEditorStateChange(editorState) {
    this.setState({ editorState });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShowPreview() {
    this.setState({ showPreview: true });
  }

  handleClosePreview() {
    this.setState({ showPreview: false });
  }

  handleCloseDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  removeArticle() {
    this.setState({ showDeleteModal: true });
  }

  async handleDeleteArticle() {
    const { id, token, history } = this.props;
    this.setState({ deleting: true });

    const removeArticleResponse = await fetch(`${apiUrl}/admin/blog/remove?token=${token}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id
      })
    });

    const removeArticleJson = await removeArticleResponse.json();

    if (removeArticleJson.success) {
      await this.props.showArticleDeletedNotification();
      history.push(`/blog`);
    }
  }

  async componentDidMount() {

    const { id, token } = this.props;

    if (id) {
      const articleResp = await fetch(`${apiUrl}/admin/blog/article/${id}?token=${token}`);
      const articleJson = await articleResp.json();
      
      if (articleJson.success) {

        const { articleData } = articleJson;
        const { title, abstract, article } = articleData;
  
        this.setState({
          title,
          abstract,
          editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(article)))
        });
      } else {
        this.setState({ articleNotFound: true });
      }
    }

    this.setState({ isLoading: false });
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ submitting: true });

    const { title, abstract, editorState } = this.state;
    const { id, token, history } = this.props;
    const article = JSON.stringify(convertToRaw(editorState.getCurrentContent()));

    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        title,
        abstract,
        article,
        id
      })
    };

    const response = !id ?
    await fetch(`${apiUrl}/admin/blog/add?token=${token}`, params) :
    await fetch(`${apiUrl}/admin/blog/update?token=${token}`, params);

    const json = await response.json();

    if (json.success) {
      this.setState({ show: true });

      if (!id) {
        await this.props.showArticleCreatedNotification();
        history.push(`/blog`);
      } else {
        this.setState({ submitting: false });
      }
    } else {
      this.setState({ submitting: false });
    }

  }

  render() {

    const {
      isLoading,
      title,
      abstract,
      editorState,
      show,
      showPreview,
      submitting,
      articleNotFound,
      showDeleteModal,
      deleting
    } = this.state;
    const { id } = this.props;

    if (isLoading) return (<AppSpinner />);
    if (articleNotFound) return (<h1 className="not-found-error">El artículo especificado no existe.</h1>);

    return (
      <div className="blog-article-component">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="blog-article-options">
                <Link to="/blog">
                  <Button variant="secondary">
                    Atrás
                  </Button>
                </Link>
                
                {
                  id &&
                  <Button variant="danger" onClick={this.removeArticle}>
                    Eliminar artículo
                  </Button>
                }
                
              </div>
            </Col>
            
            <Col xs={12}>
              <Form onSubmit={this.handleSubmit}>
                <Form.Group>
                  <Form.Label><strong>Título:</strong></Form.Label>
                  <Form.Control
                    name="title"
                    type="text"
                    placeholder="Título del artículo"
                    required
                    value={title}
                    onChange={this.handleInputChange} 
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label><strong>Resumen:</strong></Form.Label>
                  <Form.Control
                    name="abstract"
                    as="textarea"
                    rows="4"
                    placeholder="Resumen del artículo"
                    required
                    value={abstract}
                    onChange={this.handleInputChange}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label><strong>Artículo:</strong></Form.Label>
                  
                  <Editor 
                    editorState={editorState}
                    wrapperClassName="rich-editor demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={this.onEditorStateChange}
                  />

                  <Button variant="primary" onClick={this.handleShowPreview}>
                    Preview
                  </Button>

                </Form.Group>
                <div className="form-buttons">

                  <Link to="/blog">
                    <Button variant="secondary">
                      Atrás
                    </Button>
                  </Link>

                  <Button type="submit" className="nibi-btn">
                    {
                      submitting ? <Spinner animation="border" variant="warning" size="sm" /> : 'Guardar cambios'
                    }
                  </Button>
                </div>

              </Form>

            </Col>
          </Row>
        </Container>

        <Modal show={showPreview} onHide={this.handleClosePreview} dialogClassName="modal-90w">
          <Modal.Header closeButton>
            <Modal.Title>Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body dangerouslySetInnerHTML={{ __html: getHtml(editorState) }}>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClosePreview}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
        
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Cambios guardados</Modal.Title>
          </Modal.Header>
          <Modal.Body>Se han guardado los cambios</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose}>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showDeleteModal} onHide={this.handleCloseDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar artículo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              deleting ? <AppSpinner /> :
              <>
                <Alert variant="warning">
                  <p>
                    Esta acción no se puede deshacer.
                    ¿Seguro que quiere elminar el artículo?
                  </p>
                </Alert>

                <div className="delete-article-btns">
                  <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
                    Cancelar
                  </Button>
                  <Button variant="danger" onClick={this.handleDeleteArticle}>
                    Eliminar
                  </Button>
                </div>
              </>
            }
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

const BlogArticleComponent = connect(select, mapDispatchToProps)(ConnectedBlogArticleComponent);

export default BlogArticleComponent;
